import React, { useContext } from 'react';
import { useModal } from '@adserve/adserve-react-components';
import { Cell, InputNumberCell } from '../../../generic/AsTable/Standard';
import { tableCellStyle } from '../CampaignBriefStyles';
import { AirtimePlanningContext } from '../../../../contexts/AirtimePlanningContext';

const valueColumnsStyle = {
    ...tableCellStyle,
    justifyContent: 'flex-start',
    paddingLeft: 10
};

const CustomDiscountsDataRow = ({
    entity = {},
    index,
    scrollPx,
    onHover,
    isHighlighted,
    onChange,
    rowHeight,
    visibleRows,
    readOnly,
    hideEditable = false
}) => {
    const { addMessage } = useModal();
    const { showInvalidatePlanMessage } = useContext(AirtimePlanningContext);

    /**
     * mouseEnter event handler for all cells in this row
     * used for row highlighting and dragging
     * @param {Event} event - event
     */
    const onMouseEnter = (event) => {
        typeof onHover === 'function' && onHover(index);
    };

    /**
     * mouseLeave event handler for all cells in this row
     * @param {Event} event - event
     */
    const onMouseLeave = (event) => typeof onHover === 'function' && onHover(-1);

    const onNumberChange = (event) => {
        const value = event.target.value === '' ? null : parseInt(event.target.value);
        if (!isNaN(value)) {
            if (value > entity.percentageValue) {
                addMessage({
                    message: window.translate(`Amount cannot be greater than ${entity.percentageValue}.`),
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });

                return;
            }

            onChange({ ...entity, campaignPercentageValue: value });
            showInvalidatePlanMessage(event.target); // ASSP-7530
        }
    };

    return (
        <>
            <Cell
                area={`discount${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{ ...tableCellStyle, borderWidth: '0 1px 1px 1px' }}
            >
                {entity?.discountType?.name}
            </Cell>
            <Cell
                area={`maximum${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={valueColumnsStyle}
            >
                {entity.percentageValue ? `${entity.percentageValue}%` : ''}
            </Cell>
            {hideEditable ? (
                <Cell
                    area={`amount${index}`}
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    style={valueColumnsStyle}
                >
                    {entity.campaignPercentageValue ? `${entity.campaignPercentageValue}%` : ''}
                </Cell>
            ) : (
                <InputNumberCell
                    area={`amount${index}`}
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    value={entity.campaignPercentageValue}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    onChange={onNumberChange}
                    disabled={readOnly}
                    inputStyle={tableCellStyle}
                />
            )}
        </>
    );
};

export default CustomDiscountsDataRow;
